export const SIMPLE_PAGE: string = "SIMPLE_PAGE";
export const SIMPLE_PAGE_SUCCESS: string = "SIMPLE_PAGE_SUCCESS";
export const SIMPLE_PAGE_ERROR: string = "SIMPLE_PAGE_ERROR";
